import { MatDialog } from '@angular/material/dialog';
import { map, Observable } from 'rxjs';

import { DialogComponent } from '@shared/components/dialog/dialog.component';
import { DialogData } from '@shared/models/dialog.model';

const DISCARD_DIALOG_DATA: DialogData = {
  title: 'Discard Changes?',
  contentType: 'string',
  content: 'You have unsaved changes.',
  disableClose: true,
  showFooter: true,
  showCloseButton: false,
  actions: [
    {
      label: 'Discard',
      value: true,
      type: 'primary',
      handler: (_component, dialogRef): void => {
        dialogRef.close(true);
      },
    },
    {
      label: 'Cancel',
      value: false,
      handler: (_component, dialogRef): void => {
        dialogRef.close(false);
      },
    },
  ],
};

export const openInvoiceValidationDiscardDialog = (dialog: MatDialog): Observable<boolean> => {
  const dialogRef = dialog.open(DialogComponent, {
    data: DISCARD_DIALOG_DATA,
    disableClose: true,
    autoFocus: true,
    width: '420px',
  });

  return dialogRef.afterClosed().pipe(map((result) => result === true));
};
